import { layout } from '../../../App.routing'
import { GetMainSectionFn } from '../custom-topic-routes'

export const getFoodRouteInfo: GetMainSectionFn = (sectionBuilder) => {
    return [
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                teaserMode: 'visible',
                cardOrientation: { type: 'Landscape-Portrait' },

                dataDefinitionArgs: {
                    type: 'curation',
                    name: 'food',
                    offset: 0,
                    pageSize: 4,
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: 'hidden',
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                loadMoreEnabled: true,

                sectionHeader: {
                    heading: 'Latest',
                    section: 'lifestyle',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['lifestyle/food'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 8,
                    },
                },
            },
        }),
    ]
}
